/**
 * EmailMismatchBlock — logged-in SUB_DELEGATE, invite email mismatch (plan §7.4).
 * Security boundary: email must match. Primary CTA signs out.
 */

import { Link } from 'react-router-dom';
import { InviteSignupShell } from '@/shared/components/invite-signup';

export type EmailMismatchBlockProps = {
  inviteEmail: string;
  currentUserEmail: string;
  ownerName: string;
  onSignOut: () => void;
};

export const EmailMismatchBlock = ({
  inviteEmail,
  currentUserEmail,
  ownerName,
  onSignOut,
}: EmailMismatchBlockProps) => (
  <InviteSignupShell>
    <h2 className="font-recoleta text-white md:w-full text-3xl md:text-4xl">
      Invitation sent to a different email
    </h2>

    <p className="font-termina text-white max-md:text-xl max-md:py-8 py-6">
      This invitation was sent to <strong>{inviteEmail}</strong>, but you're
      signed in as <strong>{currentUserEmail}</strong>. To accept the invitation
      as that email, sign out first. Or ask <strong>{ownerName}</strong> to
      resend the invitation to your current address.
    </p>

    <div className="py-8 gap-4 flex flex-col">
      <button
        type="button"
        onClick={onSignOut}
        className="font-termina bg-[#E2A807] font-black rounded-3xl py-3 px-6 w-max uppercase cursor-pointer hover:bg-[#c99006] active:scale-[0.98] transition-all duration-150"
      >
        Sign Out
      </button>

      <Link
        to="/"
        className="font-termina text-white hover:font-bold underline mt-2"
      >
        Cancel
      </Link>
    </div>
  </InviteSignupShell>
);
